import { combineReducers } from 'redux'
import { companies } from './companies'
import { isLoading } from './isLoading'
import { user } from './user'
import { news } from './news'
import { categories } from './categories'
import {premiumPlans} from './plans'
export const rootReducer = combineReducers({
	companies,
	isLoading,
	user,
	news,
	categories,
	premiumPlans
})
